<template>
    <v-select
        :value="value"
        @input="$emit('input', $event)"
        :items="data"
        :loading="loading"
        :error-messages="errors"
        :messages="messages"
        v-bind="$attrs">
        <template v-slot:item="{item}">
            <div>
                <v-badge dot inline left :color="renderColor(item.id)"></v-badge>
                {{item.name}}
            </div>
        </template>
        <template v-slot:selection="{item}">
            <div>
                <v-badge dot inline left :color="renderColor(item.id)"></v-badge>
                {{item.name}}
            </div>
        </template>
    </v-select>
</template>

<script>
import { getSchedulingStates } from './../../services/scheduling';
import { states } from './../../data/sales/scheduling/states';

export default {
    name: "PumpsSelect",
    props: {
        itemId: [String, Number],
        value: [String, Number]
    },
    data() {
        return {
            data: [],
            loading: false,
            errors: [],
            messages: []
        }
    },
    methods: {
        async fetchSchedulingStates() {
            try {
                this.loading = true;
                let resp = await getSchedulingStates();
                this.data = resp.data;
                this.loading = false;
            } catch(error) {
                this.setError(this.extractErrorMessage(error));
                this.loading = false;
            }
        },
        setError(error) {
            this.errors.push(error);
        },
        clearError() {
            this.errors = [];
        },
        extractErrorMessage(error) {
            return error.response ? error.response.data.message : error;
        },
        clearData() {
            this.data = [];
        },
        reset() {
            this.clearError();
            this.clearData();
        },
        renderColor(stateId) {
            let state = states.find(each => each.id == stateId);
            return state ? state.color : "black";
        },
    },
    created() {
        this.fetchSchedulingStates();
    }
}
</script>

<style>

</style>